import slider1 from "../assets/banner-images/slider1.jpeg";
import mobileSlider1 from "../assets/banner-images/mobileSlider1.jpeg";


export const localSliderData = [
  {
    id: 1,
    title: "99gift-ae-uae-national-day-banner-desktop",
    image: slider1,
    mobileSliderImage: mobileSlider1,
    url: "https://99gift.ae/collections/uae-national-day-collection",
    url_utm: null,
  },
  {
    id: 2,
    title: "99gift-ae-uae-national-day-banner-mobile",
    image: slider1,
    mobileSliderImage: mobileSlider1,
    url: "https://99gift.ae/collections/uae-national-day-collection",
    url_utm: null,
  },
];

export const getDummySliderData = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        status: true,
        data: localSliderData,
        message: "Data fetched successfully"
      });
    }, 1500);
  });
};
